
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalReturnItemsGrid extends Serenity.EntityGrid<POSApprovalReturnItemsRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalReturnItems'; }
        protected getDialogType() { return POSApprovalReturnItemsDialog; }
        protected getIdProperty() { return POSApprovalReturnItemsRow.idProperty; }
        protected getInsertPermission() { return POSApprovalReturnItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalReturnItemsRow.localTextPrefix; }
        protected getService() { return POSApprovalReturnItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true; 
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }

}